import { forwardRef, ImgHTMLAttributes } from 'react';
import { cn } from '@utils/cn';
import styles from '@/styles/components/Avatar.module.scss';

export interface AvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fallback?: string;
}

const sizeStyles: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: styles.sm!,
  md: styles.md!,
  lg: styles.lg!,
  xl: styles.xl!,
};

const Avatar = forwardRef<HTMLImageElement, AvatarProps>(
  ({ className, size = 'md', fallback, alt, ...props }, ref) => {
    const initials = fallback
      ? fallback
          .split(' ')
          .map((n) => n[0])
          .join('')
          .toUpperCase()
          .slice(0, 2)
      : '??';

    return (
      <div className={cn(styles.avatar, sizeStyles[size], className)}>
        {props.src ? (
          <img
            ref={ref}
            alt={alt || fallback || 'Avatar'}
            className={styles.image}
            {...props}
          />
        ) : (
          <span>{initials}</span>
        )}
      </div>
    );
  }
);

Avatar.displayName = 'Avatar';

export default Avatar;
